import type { Transition, Variants } from "motion/react";

/**
 * Emil Kowalski spring physics guidelines:
 * - SPRING_SNAPPY (400 / 30): tactile micro-interactions (buttons, badges, icons, switches)
 * - SPRING_FLUID (260 / 20): layout morphing, active pill indicator, expanding panels
 * - SPRING_GENTLE (180 / 24): page navigation, modal entry/exit, sheets
 * - SPRING_BOUNCE (500 / 25): lottery balls, celebratory counters, score pops
 */

export const SPRING_SNAPPY: Transition = {
  type: "spring",
  stiffness: 400,
  damping: 30
};

export const SPRING_FLUID: Transition = {
  type: "spring",
  stiffness: 260,
  damping: 20
};

export const SPRING_GENTLE: Transition = {
  type: "spring",
  stiffness: 180,
  damping: 24
};

export const SPRING_BOUNCE: Transition = {
  type: "spring",
  stiffness: 500,
  damping: 25
};

export const TACTILE_TAP = {
  scale: 0.97
};

export const TACTILE_HOVER = {
  scale: 1.01,
  y: -2
};

export const FADE_VARIANTS: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
};

export const SLIDE_UP_VARIANTS: Variants = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0, transition: SPRING_FLUID },
  exit: { opacity: 0, y: -8, transition: { duration: 0.15 } }
};

export const STAGGER_CONTAINER_VARIANTS: Variants = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.04,
      delayChildren: 0.02
    }
  }
};

export const POP_ITEM_VARIANTS: Variants = {
  initial: { opacity: 0, scale: 0.8, y: 8 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: SPRING_BOUNCE
  }
};
